export default __webpack_public_path__ + "static/media/card-01.1519793a.jpg";